<template>
    <div class="pack-box gift-choice gift-choice__tableau "  >
    <div class="pack-title">
        <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux" />
        <h3> Choisissez votre <span class="orange-text">cadeau</span></h3>
    </div>
    <h6 class="text-uppercase orange-text">Accédez à un catalogue complet de cadeaux</h6>
    <p>
        Le consommateur devrait toujours avoir le choix. C’est pourquoi, Test
        Achats vous propose de choisir parmi un catalogue de cadeaux variés&nbsp;:
    </p>
    <div class="tableau">
        <div class="tableau-title-container">
            <p class="tableau-title">Quelques  exemples  de cadeaux </p>
<!--            <p class="product-offre tableau-title">Offre</p>-->
            <p class="product-price tableau-title">Prix</p>
        </div>
        <div class="product-row" v-for="(elem, index) in tableau">
<!--            <p class="product-name" v-if="index === 0 || index === 2"> <span style="text-decoration: line-through;text-transform: uppercase">{{ elem }}</span> <span style="color: #fa5528;text-transform: uppercase">RUPTURE DE STOCK</span> </p>-->
            <p class="product-name">{{ elem }}</p>
<!--            <p class="product-offre">2€ / 2 mois</p>-->
            <p class="product-price">GRATUIT</p>
        </div>
        <p class="asterix">*Contribution personnelle supplémentaire.
            Paiement possible par carte de crédit uniquement.</p>
    </div>
    </div>
</template>

<script>
export default {
    name: "GiftChoiceTableau",
    data() {
        return {
            tableau: [
                'Mixer 5000 - Philips',
                'Machine à Café',
                'Aifryer',
                'Mini blender - HKoenig',
                'Presse Agrumes - HKoenig',
                'Cuiseur vapeur - HKoenig',
                'Gaufrier & croque - Livoo',
            ],
        }
    },

}
</script>

<style scoped>

</style>
